var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneSlashRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.74 26.327l-20-22a1 1 0 10-1.48 1.345L10 10.886V16a6 6 0 009.239 5.05l1.36 1.5A8 8 0 018 16a1 1 0 10-2 0 10.014 10.014 0 009 9.95V29a1 1 0 102 0v-3.051a9.968 9.968 0 004.953-1.914l3.307 3.637a1 1 0 101.48-1.345zM16 20a4 4 0 01-4-4v-2.914l5.865 6.453a4 4 0 01-1.865.46zM10.895 4.847A6 6 0 0122 8v7.554a1 1 0 11-2 0V8a4 4 0 00-7.405-2.101 1 1 0 11-1.7-1.052zm12.56 14.062a7.965 7.965 0 00.545-2.91 1 1 0 112 0 9.955 9.955 0 01-.682 3.637 1.002 1.002 0 01-1.636.374 1.001 1.001 0 01-.227-1.101z"
  })));
}
export default SvgMicrophoneSlashRegular;